import React, { useCallback, useMemo } from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { CenteredModal, useModalState } from '@app/core';
import { Offer, OfferType, useOffers } from '@app/api';
import { OfferList } from '../Offers';
import { CreditsInfosSection } from './CreditsInfosSection';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const useStyles = createUseStyles((theme: Theme) => ({
  infoSection: {
    marginBottom: theme.marginBase * 3,
  },
}));

interface Props {
  isOpen: boolean;
  onRequestClose?: () => any;
}

export const UnlockCreditsModal = ({ isOpen, onRequestClose }: Props) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const onOfferSelect = useCallback(
    (offer: Offer) => navigate(`/payment?offer=${offer.id}`),
    [navigate],
  );

  const { data: offers } = useOffers();
  const creditOffers = useMemo(() => {
    if (!offers) return [];
    return offers
      .filter((offer) => offer.type === OfferType.CREDIT)
      .sort((a, b) => {
        if (a.prices.eur === 0) return 1;
        if (b.prices.eur === 0) return -1;
        return a.prices.eur - b.prices.eur;
      });
  }, [offers]);

  return (
    <>
      <CenteredModal
        isOpen={isOpen}
        onRequestClose={onRequestClose}
        xlarge={creditOffers.length !== 4}
        xxlarge={creditOffers.length === 4}
        title={t('billing.emptyPage.title')}
      >
        <CreditsInfosSection className={classes.infoSection} />
        <OfferList offers={creditOffers} onClick={onOfferSelect} />
      </CenteredModal>
    </>
  );
};
